module.exports = __webpack_public_path__ + "static/media/pdx.4fa5355c.csv";